import React from "react";
import BaseComponent from "../baseComponent";
import ProductListComponent from "./productsComponent";
import {eventConstants, pathConstants} from "../../constants";
import {history} from "../../managers/history";
import Utility, {dispatchAction} from "../../utility";
import itemsService from "../../services/items";
import {connect} from "react-redux";

class ProductsComponent extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.refreshList()
    }

    refreshList = async () => {
        this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(itemsService.getItemsList());
        this.props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err)
            return Utility.apiFailureToast("Unable to fetch items");
        res.sort((a, b) => new Date(b.modifiedOn).getTime() - new Date(a.modifiedOn).getTime());
        this.setState({itemsList: res})
    };

    onAddNewProductClicked = () => {
        history.push(pathConstants.DASHBOARD_MENU.ADD_PRODUCT);
    };

    render() {
        return (
            <ProductListComponent
                state={this.state}
                refreshList={this.refreshList}
                onAddNewProductClicked={this.onAddNewProductClicked}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(ProductsComponent);
